import { asyncToGenerator as _asyncToGenerator, regeneratorRuntime as _regeneratorRuntime } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { jsx } from '@emotion/react';
import { ImageUploadField } from '@bucketplace/commerce-admin-ui';
import '../../../contexts/internal/StickyContext.js';
import '../../../contexts/internal/EditorContext.js';
import { useEditorInfoContext } from '../../../contexts/external/EditorInfoContext.js';
import 'lodash-es';
import '@bucketplace/ui';
import 'use-context-selector';
import 'qs';
import 'query-string';
import { useFieldForm } from '../../../hooks/useFieldForm.js';
import '@bucketplace/bucket-log';
import { FieldItem } from '../../FieldItem.js';
import { URLInput } from '../URLInput.js';
import { validateImageURL } from './utils.js';

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var PATH = 'uploads/exhibitions/contents';
/** 최대 업로드 수 (기존에도 1개 단위로 업로드) */
var DEFAULT_MAX_COUNT = 1;
var DEFAULT_LIMIT = 10 * 1024;
var ACCEPT = '.jpg, .jpeg, .png, .webp, .gif';
function ImageField(_ref) {
  var name = _ref.name,
    label = _ref.label,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? '이미지 URL 입력' : _ref$placeholder;
  var _useEditorInfoContext = useEditorInfoContext(),
    uploadEndpoint = _useEditorInfoContext.uploadEndpoint;
  var _useFormContext = useFormContext(),
    setValue = _useFormContext.setValue,
    watch = _useFormContext.watch;
  var _useFieldForm = useFieldForm(),
    fields = _useFieldForm.fields,
    errors = _useFieldForm.errors,
    register = _useFieldForm.register,
    _onChange = _useFieldForm.onChange,
    trigger = _useFieldForm.trigger,
    setStateValue = _useFieldForm.setValue;
  var file = watch(name);
  var errorMessage = errors['url'];

  // Textarea에 동기화
  var handleAfterUpload = function handleAfterUpload(value) {
    var _value$url;
    setStateValue('url', (_value$url = value === null || value === void 0 ? void 0 : value.url) !== null && _value$url !== void 0 ? _value$url : '');
  };

  // 업로드된 Image 삭제 시,
  useEffect(function () {
    if (!file) {
      setStateValue('url', '');
    }
  }, [file]);
  useEffect(function () {
    register('url', {
      defaultValue: file,
      validate: function () {
        var _validate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(value) {
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                if (value) {
                  _context.next = 2;
                  break;
                }
                return _context.abrupt("return");
              case 2:
                _context.prev = 2;
                _context.next = 5;
                return validateImageURL(value);
              case 5:
                _context.next = 10;
                break;
              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](2);
                return _context.abrupt("return", '유효하지 않은 이미지 URL입니다.');
              case 10:
              case "end":
                return _context.stop();
            }
          }, _callee, null, [[2, 7]]);
        }));
        function validate(_x) {
          return _validate.apply(this, arguments);
        }
        return validate;
      }()
    });
  }, []);
  return jsx(React__default.Fragment, null, jsx(ImageUploadField, {
    name: name,
    label: label,
    endpoint: uploadEndpoint,
    path: PATH,
    accept: ACCEPT,
    maxCount: DEFAULT_MAX_COUNT,
    fileLimitSize: DEFAULT_LIMIT,
    useArrayType: false,
    serializer: {
      serialize: function serialize(url) {
        return {
          url: url
        };
      },
      deserialize: function deserialize(data) {
        return data.url;
      }
    },
    customCss: ImageUploadFieldCss,
    onAfterUpload: handleAfterUpload
  }), jsx(FieldItem, {
    error: true,
    hint: errorMessage,
    hintAlign: "end"
  }, jsx(URLInput, {
    value: fields['url'],
    readOnly: !!file,
    placeholder: placeholder,
    onChange: function onChange(value) {
      _onChange('url', value);
    },
    onBlur: /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return trigger('url');
          case 2:
            _context2.t0 = !_context2.sent;
            if (!_context2.t0) {
              _context2.next = 5;
              break;
            }
            _context2.t0 = fields['url'];
          case 5:
            if (!_context2.t0) {
              _context2.next = 7;
              break;
            }
            setValue(name, fields['url']);
          case 7:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))
  })));
}
var ImageUploadFieldCss = process.env.NODE_ENV === "production" ? {
  name: "11rcwxl",
  styles: "margin-bottom:4px"
} : {
  name: "ev10vq-ImageUploadFieldCss",
  styles: "margin-bottom:4px;label:ImageUploadFieldCss;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

export { ImageField };
//# sourceMappingURL=ImageField.js.map
